<template>
  <div class="p-icon-user-image" :style="setStyleObj">
    <!-- DX_IC-739 画像の大きさを動的に処理 -->
    <div class="p-icon-user-image__inner" :style="setStyleObj">
      <slot>
        <img v-if="!isLoading" src="/static/img/user-icon.png" alt />
      </slot>
      <div v-if="upload" class="p-icon-user-image__upload"></div>
      <div v-if="unread" class="p-icon-user-image__unread">
        <i class="p-icon-user-image__unread__dot"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import globals from "@/general/store/modules/globals";
import { Options, Vue } from 'vue-class-component';
import { mapState } from "vuex";

@Options({
  props: {
    size: { type: Number, default: 32 },
    spSize: { type: [Number, Boolean], default: false },
    upload: { type: Boolean, default: false },
    unread: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }
  }
})
export default class IconUserImage extends Vue {
  size!: number;
  spSize!: number;
  upload!: boolean;
  unread!: boolean;
  isLoading!: boolean;

  isSp = globals.isSpScreenWidth;

  get setStyleObj() {
    const size = this.size;
    const spSize = this.spSize;
    const isSp = this.isSp;
    const spImageSize = spSize || size;
    const resultImageSize = isSp ? spImageSize : size;
    const calcRem = (value: any) => `${value / 16}rem`;

    return {
      width: calcRem(resultImageSize),
      minWidth: calcRem(resultImageSize),
      height: calcRem(resultImageSize)
    };
  }
}
</script>

<style lang="scss" scoped>
.p-icon-user-image {
  position: relative;

  &__inner {
    overflow: hidden;
    border-radius: 50%;
    line-height: 0;
  }

  img,
  svg {
    @include object-fit("contain");
    width: 100%;
    height: 100%;
  }

  &__unread {
    width: rem(12);
    height: rem(12);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: #ffffff;
    border-radius: 50%;

    &__dot {
      width: rem(10);
      height: rem(10);
      display: block;
      background-color: $common-primary;
      border-radius: 50%;
    }
  }
}
</style>
